import {mapShopBalloon} from "../lib/mapShopBalloon";
import {renderShopBalloon} from "../lib/renderShopBalloon";
import {Shop, SHOP_TYPE} from "@/entities/shop";
import {YandexPlacemark, YandexPlacemarkActions} from "@/shared/ui/YandexMap";

type Props = {
    shop: Shop;
    onActionsReady?: (actions: YandexPlacemarkActions | null) => void;
}

export const ShopPlacemark = ({shop, onActionsReady}: Props) => {
    const balloonData = mapShopBalloon(shop);

    // const hintContent = renderShopHint(balloonData); // Если в будущем будут различия
    const balloonContent = renderShopBalloon(balloonData);
    const icon = shop.tip === SHOP_TYPE.BRANDED ? '/storage/img/maps/pj.png' : '/storage/img/maps/pj-partner.png';

    return (
        <YandexPlacemark
            geometry={[shop.targetx, shop.targety]}
            options={{
                iconLayout: 'default#image',
                iconImageHref: icon,
                // balloonPanelMaxMapArea: Infinity,
            }}
            properties={{
                hintContent: balloonContent,
                balloonContent,
            }}
            modules={[
                'geoObject.addon.balloon',
                'geoObject.addon.hint',
            ]}
            onActionsReady={onActionsReady}
        />
    );
};
